<template>
  <div
    v-if="isProved || rating || isForceShow"
    class="shop-rating"
    :class="{
      'shop-rating__popular': isPopular,
      'shop-rating__modal': isModal,
    }"
  >
    <div class="shop-rating-card body-m-regular" @click.prevent="toggle">
      <div v-if="rating" class="shop-rating-info shop-rating-info__rating">
        <span>{{ rating }}</span>
        <span v-if="valuesCount < 15" class="review-count"> Мало оценок </span>
        <span v-else class="review-count">
          {{ valuesCount }} {{ numberTitles(valuesCount, labels) }}
        </span>
      </div>
      <div v-if="isProved" class="shop-rating-info shop-rating-info__proved">
        <span class="no-mobile">{{
          !isPopular ? 'Магазин проверен' : ''
        }}</span>
      </div>
    </div>
    <div
      v-if="isPopup"
      class="shop-rating-container-wrapper"
      :class="[
        align,
        {
          share,
          'shop-rating-container-wrapper__show': share,
          'shop-rating-container-wrapper__proved': isProved,
          'shop-rating-container-wrapper__rating': rating,
        },
      ]"
    >
      <div class="shop-rating-popup-extender">
        <div class="shop-rating-popup-hvostik" />
      </div>
      <div class="close-div" @click.prevent="toggle" />
      <div class="shop-rating-container shop-rating-container__proved">
        <div class="icon-close" @click.prevent="toggle" />
        <div class="proved-title">
          {{ shop.shop_info?.name }}
        </div>
        <template v-if="isProved">
          <div class="proved-status">Магазин проверен</div>
          <ul class="proved-list">
            <li>Размещается на Price более 6 месяцев</li>
            <li>Юридические данные проверены</li>
            <li>За последние 3 месяца не поступало жалоб от пользователей</li>
          </ul>
        </template>
        <template v-if="rating">
          <div class="rating-star-wrap">
            <div class="rating-star" />
            <div class="rating-star-info">
              <div class="rating-star-number">{{ rating }}</div>
              <div class="rating-star-ratings">
                ∙ {{ valuesCount }} {{ numberTitles(valuesCount, labels) }}
              </div>
            </div>
          </div>
          <div class="rating-text">
            Рейтинг составлен на основе оценок пользователей, собранных с
            крупных интернет-площадок
          </div>
        </template>
        <ui-ui-button
          v-if="!isShop"
          mode="link"
          :path="`/${shop.shop_info.product_slug}/`"
          type="secondary"
          :font-weight="400"
          class="shop-window"
        >
          Открыть витрину магазина
        </ui-ui-button>
        <button
          v-if="!isSendComplain"
          class="shop-complain"
          @click="sendComplain"
        >
          Пожаловаться
        </button>
        <div v-else class="shop-complain-ready" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useScrollLock } from '@vueuse/core';
import { useMediaQueryStore } from '~/stores/mediaQuery';
import type { ShopInfo } from '~/interfaces/api';
import { numberTitles } from '~/common/const';

const props = defineProps({
  shop: {
    type: Object as () => {
      shop_info: ShopInfo;
    },
    required: true,
  },
  labels: {
    type: Array,
    default: () => ['оценка', 'оценки', 'оценок'],
  },
  align: {
    type: String,
    default: null,
  },
  isForceShow: {
    type: Boolean,
    default: false,
  },
  isPopular: {
    type: Boolean,
    default: false,
  },
  isModal: {
    type: Boolean,
    default: false,
  },
  isShop: {
    type: Boolean,
    default: false,
  },
  isOffer: {
    type: Boolean,
    default: false,
  },
});

const isSendComplain = ref(true);
const html = ref<HTMLElement | null>(null);
const isLocked = useScrollLock(html);
const isPopup = computed(() => {
  return props.isOffer || props.isPopular;
});
const rating = computed(() => {
  if (Number(props.shop?.shop_info?.merchant_rating) === 0) return null;
  return props.shop?.shop_info?.merchant_rating || null;
});
const isProved = computed(() => {
  return props.shop?.shop_info?.proved_merchant;
});
const valuesCount = computed(() => {
  return props.shop?.shop_info?.merchant_rating_grades
    ? Number(props.shop.shop_info.merchant_rating_grades)
    : 0;
});
const mediaStore = useMediaQueryStore();
const isTablet = computed(() => mediaStore.isTablet);
const share = ref<boolean>(false);
const toggle = () => {
  if (isTablet.value) {
    share.value = !share.value;
    isLocked.value = share.value;
  }
};
const sendComplain = () => {
  isSendComplain.value = true;
};
onMounted(() => {
  html.value = document.querySelector('html');
});
</script>

<style scoped lang="scss" src="./ShopRatingScss.scss" />
